import network from '@/services/network';
import { ApiResponse, BookingFieldConfig, UpdateBookingFieldsRequest } from '@/types';
import { ErrorResponse } from '@/utils';

/**
 * Buchungsfelder haengen unter ihrem Pool (Entscheid Alex 09.08.2026, §0g) —
 * wie die Quellen. Kein eigenes Recht: wer den Pool pflegt, pflegt seine
 * Felder.
 */
const basis = (poolId: number) => `/meeting-pools/${poolId}/booking-fields`;

const getBookingFields = async (poolId: number): Promise<ApiResponse<BookingFieldConfig>> => {
  try {
    const { data } = await network.get<ApiResponse<BookingFieldConfig>>(basis(poolId));
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

/**
 * Setzt die Liste EINES Bereichs (Standard oder eine Quelle) und liefert den
 * vollstaendigen neuen Stand zurueck — der Dialog muss danach nicht
 * nachladen.
 *
 * Die Liste wird ERSETZT, nicht ergaenzt: die Reihenfolge im Array ist die
 * Anzeigereihenfolge, und ein entferntes Feld erkennt der Server daran, dass
 * es nicht mehr mitkommt.
 */
const setBookingFields = async (
  poolId: number,
  payload: UpdateBookingFieldsRequest,
): Promise<ApiResponse<BookingFieldConfig>> => {
  try {
    const { data } = await network.put<ApiResponse<BookingFieldConfig>>(basis(poolId), payload);
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const bookingFieldApi = {
  getBookingFields,
  setBookingFields,
};

export default bookingFieldApi;
